export const importTypes = [
  { value: "False", name: "Import" },
  { value: "True", name: "Reimport" },
];
